import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import * as React from 'react';
import { DatasheetFormatManagementFormat } from '../../components/datasheet-save-as/datasheet-save-as.controller';

export const useDatasheetSavingController = () => {
  const [folderPickerOpened, setFolderPickerOpened] = React.useState(false);

  const openFolderPicker = React.useCallback(() => {
    setFolderPickerOpened(true);
  }, []);

  const closeFolderPicker = React.useCallback(() => {
    setFolderPickerOpened(false);
  }, []);

  const handleSaveAsSubmit = React.useCallback(
    async (payload: { format: DatasheetFormatManagementFormat; folder: FolderPrimaryListDto }) => {
      setFolderPickerOpened(false);
    },
    []
  );

  return {
    folderPickerOpened,
    openFolderPicker,
    closeFolderPicker,
    handleSaveAsSubmit,
  };
};